module.exports = __webpack_public_path__ + "img/Image37.f576fe7b.png";